import * as React from "react";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { Icon } from "../icon/Icon";
export var IconWithText = function (_a) {
    var icon = _a.icon, styleId = _a.styleId, className = _a.className, backgroundClassName = _a.backgroundClassName, backgroundSize = _a.backgroundSize, children = _a.children, _b = _a.tooltipAnchor, tooltipAnchor = _b === void 0 ? IdTooltipAnchor.Bottom : _b, tooltipLoca = _a.tooltipLoca, _c = _a.tooltipVerticalAdjust, tooltipVerticalAdjust = _c === void 0 ? -IdTooltipAdjust.Large : _c, _d = _a.centerText, centerText = _d === void 0 ? true : _d;
    var mainClassName = className ? className : "icon-with-text";
    var size = backgroundSize ? "-" + backgroundSize : "";
    var centerTextClass = centerText ? "centered" : "right";
    var background = backgroundClassName
        ? backgroundClassName + "-background" + size + " " + backgroundClassName + "-background"
        : IdStyles.StatBackground;
    return tooltipLoca === undefined ? (React.createElement("div", { className: mainClassName + " " + background + " " + centerTextClass },
        React.createElement("div", { className: IdStyles.TextBoldAccent }, children),
        React.createElement(Icon, { icon: icon, styleId: styleId }))) : (React.createElement(TooltipText, { id: tooltipLoca, anchor: tooltipAnchor, adjustVertical: tooltipVerticalAdjust },
        React.createElement("div", { className: mainClassName + " " + background + " " + centerTextClass },
            React.createElement("div", { className: IdStyles.TextBoldAccent }, children),
            React.createElement(Icon, { icon: icon, styleId: styleId }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon-with-text/IconWithText.tsx
// module id = 591
// module chunks = 3